<template>
    <div class="home-container page beauty">
        <van-nav-bar class="nav-bar" :title="$t('同城约')">
            <template #right>
                <div @click="addrShow = true" style="font-size: 14px;">
                    {{ $t('地区') }}
                </div>

            </template>
        </van-nav-bar>
        <div class="navs animate__animated animate__fadeInDown" v-if="addrShow">
            <div class="addrList_item" v-for="(item, index) in addrList" :key="index" @click="addrShow = false">{{
                item.name }}
            </div>
        </div>
        <div class="item hot">
            <div class="tj">
                <ul>
                    <li v-for="(v, key) in movielist_1" :key="key" @click="toPlayVideo(v.id)">
                        <div class="left">
                            <p>ID:#{{ v.id }}</p><span>{{ $t('昵称') }}：{{ v.xuanfei_name }}</span><span>{{ $t('类型')
                                }}：<span v-for="(li, indexs) in v.service_data" :key="indexs">{{ li
                                }}/</span></span><span>{{ $t('所在地区') }}：{{
                                        v.address }}</span><span>{{ $t('服务项目') }}：{{ $t('会员专享') }}</span>
                            <div><span><i class="van-badge__wrapper van-icon van-icon-browsing-history"
                                        style="color: rgb(215, 215, 215); font-size: 14px;"></i>48699</span><span><i
                                        class="van-badge__wrapper van-icon van-icon-like"
                                        style="color: rgb(255, 141, 140); font-size: 14px;"></i>10.0</span></div>
                        </div>
                        <div class="right">
                            <div class="van-image van-image--round" style="width: 86px; height: 86px;"><img
                                    :src="v.img_url" class="van-image__img" style="object-fit: cover;"></div>
                        </div>
                        <div class="top"> {{ $t('已认证') }} </div>
                    </li>
                </ul>
            </div>

            <div class="van-list__finished-text" style="font-size: 12px;">{{ $t('为保护女嘉宾隐私') }}</div>
        </div>

    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            gameitem: [{}, {}, {}, {}],
            lotteryitem: [{}, {}, {}, {}],
            isLoading: false,
            activeKey: 0,
            page: 1,
            movielist_1: [],
            finished: false,
            count: 0,
            addrShow: false,
            addrList: [],

        };
    },
    methods: {
        toPlayVideo(id) {

            if (!localStorage.getItem('token') && this.$store.getters.getBaseInfo.video_login == 1) {
                this.$router.push({ path: '/Login' })
            } else {
                if (id) {
                    this.$router.push({ path: '/nHomeDetail?id=' + id })
                }
            }
        },
        onRefresh() {
            setTimeout(() => {
                Toast(this.$t("reservation.refresh"));
                this.isLoading = false;
            }, 500);
        },
        toLottery(key, id) {
            if (!localStorage.getItem('token')) {
                this.$router.push({ path: '/Login' })
            } else {
                this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id })
            }
        },
        getAddress() {
            this.$http({
                method: 'get',
                url: 'address_list'
            }).then(res => {
                this.addrList = res.data;
            });
        },
        getGameItem() {
            this.$http({
                method: 'get',
                url: 'lottery_list'
            }).then(res => {
                this.gameitem = res.data;
            })
        },
        onChange(index) {
            this.$http({
                method: 'get',
                data: { class: index },
                url: 'lottery_list'
            }).then(res => {
                this.gameitem = res.data;
            })
        },
        getLotteryItem() {
            this.$http({
                method: 'get',
                url: 'lottery_class'
            }).then(res => {
                this.lotteryitem = res.data;
            })
        },

        back() {
            this.$router.replace('/Home')
        },


        getNhomeList() {
            this.$http({
                method: 'get',
                url: 'xuanfeilist',
                data: { page: this.page },
            }).then(res => {
                this.loading = false;
                if (this.page == 1) {
                    this.movielist_1 = res.data;
                } else {

                    this.movielist_1 = this.movielist_1.concat(res.data);
                }
                if (res.data.length == 0) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
                this.count = res.data.count;
                this.page++;
            })

        }
    },

    created() {
        this.getNhomeList();
        this.getAddress()
    }
};
</script>

<style lang='less' scoped>
.home-container {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    background-color: #f2f2f2;
}

.home-container .item {
    width: 100%;
    padding: .66667rem;
    background: #fff
}

.home-container .item>a {
    font-size: .8rem;
    color: #979799;
    padding: .66667rem 0;
    display: block
}

.home-container .item .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: .83333rem;
    color: #333;
    position: relative;
    padding-left: .66667rem
}

.home-container .item .title:before {
    content: "";
    position: absolute;
    width: .26667rem;
    height: 1rem;
    left: 0;
    background: #ff4d67
}

.home-container .item .title span {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .93333rem;
    color: rgba(0, 0, 0, .87)
}

.home-container .item .title span i {
    display: inline-block;
    margin-left: .46667rem;
    border-radius: .46667rem 0 .46667rem 0;
    background: #3f3a5b;
    color: #ebcaaf;
    padding: .04rem .6rem;
    font-size: .12rem
}

.home-container .item .title a {
    color: #797979;
    font-size: .8rem
}

.home-container .item .list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center
}

.home-container .item .list li {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25%;
    padding-top: 1.33333rem
}

.home-container .item .list li .image {
    width: 66%;
    overflow: hidden
}

.home-container .item .list li .image img {
    width: 100%
}

.home-container .item .list li p {
    font-size: .86667rem;
    padding-top: .5rem;
    color: #34196a
}



.tj ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: .26667rem solid #ffd5db;
    border-radius: .33333rem;
    margin-bottom: .66667rem;
    padding: .66667rem .66667rem;
    position: relative;
    overflow: hidden
}

.home-container .item .title:before {
    content: "";
    position: absolute;
    width: .26667rem;
    height: 1rem;
    left: 0;
    background: #ff4d67
}

.tj ul li .top {
    position: absolute;
    color: #fff;
    background: #ff4d67;
    width: 6.66667rem;
    padding: .33333rem;
    font-size: .73333rem;
    right: -35PX;
    top: 5PX;
    transform: rotate(45deg);
    text-align: center;
}

.tj ul li .left {
    text-align: left
}

.tj ul li .left>p {
    color: #fff;
    display: inline-block;
    background: linear-gradient(90deg, #d1af6f 0, #d1af6f);
    padding: .13333rem .66667rem;
    font-size: .83333rem;
    border-radius: 3.33333rem
}

.tj ul li .left>span {
    display: block;
    font-size: .8rem;
    color: #666;
    padding-left: .33333rem
}

.tj ul li .left>div,
.tj ul li .left>span:nth-child(2) {
    padding-top: .33333rem
}

.tj ul li .left>div span {
    font-size: .76667rem;
    color: #696969;
    padding-right: .66667rem
}


.beauty .navs {
    position: fixed;
    width: 100%;
    background: #fff;
    padding: 1rem;
    z-index: 99;
    top: 46PX;
    border-top: .13333rem solid #b2b2b2;
    border-bottom: .13333rem solid #b2b2b2;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.beauty .navs.ac {
    display: none
}

.beauty .navs .addrList_item {
    font-size: .76667rem;
    color: #ff4d67;
    border: 1px solid #ff4d67;
    padding: .26667rem .66667rem;
    margin-bottom: .66667rem;
    margin-right: 1rem;
    border-radius: .33333rem
}
</style>